// extracted by mini-css-extract-plugin
module.exports = {"layout":"quotation_layout__y8NJl","avatarContainer":"quotation_avatarContainer__tG8LZ","quote":"quotation_quote__UjCYc"};